(() => {
  const mount = document.getElementById('seg-widget');
  if (!mount) return;
  const src = mount.getAttribute('data-src') || '/.netlify/functions/getSegs';
  const state = { data: [], q: '' };

  const el = (tag, props = {}, ...kids) => {
    const n = document.createElement(tag);
    Object.entries(props).forEach(([k, v]) => {
      if (k === 'class') n.className = v;
      else if (k.startsWith('on') && typeof v === 'function') n.addEventListener(k.slice(2).toLowerCase(), v);
      else n.setAttribute(k, v);
    });
    kids.flat().forEach(k => typeof k === 'string' ? n.appendChild(document.createTextNode(k)) : k && n.appendChild(k));
    return n;
  };

  const toTitle = k => k.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  const searchMatch = (row, q) => {
    if (!q) return true;
    const needle = q.toLowerCase();
    return Object.values(row).some(v => (v ?? '').toString().toLowerCase().includes(needle));
  };

  const render = () => {
    mount.innerHTML = '';
    const search = el('input', {
      type: 'search', placeholder: 'Search employer, address, city, ZIP…', value: state.q, 'aria-label': 'Search',
      oninput: (e) => { state.q = e.target.value; draw(); }
    });
    search.style.cssText = 'width:100%; max-width:520px; padding:.6rem .75rem; border:1px solid #ccc; border-radius:.5rem;';
    const results = el('div', { id: 'seg-results' });
    mount.appendChild(el('div', { style: 'margin-bottom:.75rem;' }, search));
    mount.appendChild(results);
    draw();
  };

  const draw = () => {
    const results = document.getElementById('seg-results');
    if (!results) return;
    const filtered = state.data
      .filter(r => searchMatch(r, state.q))
      .sort((a, b) => (a.name || '').localeCompare(b.name || ''));

    results.innerHTML = '';
    if (filtered.length === 0) {
      results.appendChild(el('div', { style: 'padding:.75rem; color:#666;' }, 'No matching results.'));
      return;
    }

    const cols = Object.keys(filtered[0] || {});
    const table = el('table', { role: 'table', style: 'width:100%; border-collapse:collapse; font-size:14px;' });
    const thead = el('thead', {},
      el('tr', {}, ...cols.map(c =>
        el('th', { style: 'text-align:left; padding:.5rem; border-bottom:1px solid #eee;' }, toTitle(c))
      ))
    );
    const tbody = el('tbody');
    filtered.forEach(r => {
      tbody.appendChild(
        el('tr', {},
          ...cols.map(c => el('td', { style: 'padding:.5rem; border-bottom:1px solid #f4f4f4;' }, (r[c] ?? '').toString()))
        )
      );
    });
    table.appendChild(thead); table.appendChild(tbody);
    results.appendChild(table);
  };

  fetch(src, { cache: 'no-store' })
    .then(r => r.json())
    .then(json => {
      const arr = Array.isArray(json) ? json : (json.records || []);
      state.data = arr;
      render();
    })
    .catch(() => { mount.textContent = 'Couldn’t load SEG data.'; });
})();


